import React from "react";
import { Button, ButtonProps } from "@cmp-src/primitives/button";

export type ModalCancelButtonProps = ButtonProps;

/** The outline cancel button of a modal footer, full width on phones. */
export const ModalCancelButton: React.FC<ModalCancelButtonProps> = ({
  ...rest
}) => {
  return (
    <Button className="w-full sm:w-auto" variant="outline" {...rest} />
  );
};
